import { AlertMessagesService, placementCreateMenuTypes } from "../../../shared";
import { PlacementDetailsTableService } from '../services/placementDeatilsTable-service';

export const PlacementUtils = {
    /**
     * Calculating all rate unit and cost on basis of recived value of rate unit and cost
     * @param {Number} units 
     * @param {Number} rate 
     * @param {Number} cost 
     * @param {string} costMethod 
     * @param {string} feeCalcParam 
     * @returns object of rate unit and cost after calculation
     */
    getCostCalculation : (units,rate,cost,costMethod,feeCalcParam) =>{
        // if costmethod is flat or free then don't calculate, return the same value
        if(["Flat", "Free"].includes(costMethod)){
            return {units:units,rate:rate,cost:cost};
        }

        if (!rate && (units && cost)) {
            rate = cost / units;
            if (costMethod?.includes('CPM')) {
                //Divide rate by 1000 if "Cost Method" string contains CPM (Ex. CPM, dCPM, etc.) while calculating rate
                rate = rate * 1000;
            }
        } else if (!units && (rate && cost)) {
            units = cost / rate;
            if (costMethod?.includes('CPM')) {
                //Multiply units by 1000 if "Cost Method" string contains CPM (Ex. CPM, dCPM, etc.) while calculating units
                units = units * 1000;
            }
        } else if (!cost && (rate && units)) {
            cost = rate * units;
            if (costMethod?.includes('CPM')) {
                //Divide cost by 1000 if "Cost Method" string contains CPM (Ex. CPM, dCPM, etc.) while calculating cost
                cost = cost / 1000;
            }
            //If all three values are present, calculate the value of the "Rate"/"Unit" field based on the "Planned Cost" field value
        } else if (rate && units && cost && feeCalcParam) {
            if ((feeCalcParam === 'Rate' || feeCalcParam === 'Planned Cost')) {
                units = cost / rate;
                if (costMethod?.includes('CPM')) {
                    units = (cost / rate) * 1000;
                }
            } else if (feeCalcParam === 'Unit Amount') {
                rate = (cost / units);
                if (costMethod?.includes('CPM')) {
                    rate = rate * 1000;
                }
            }
        }
        return {units:units,rate:rate,cost:cost}
    },

    /**
     * Function to get the cost based on the column, value and updated value.
     * @param {String} column - The column name.
     * @param {Object} value - The value object.
     * @param {Number} updatedValue - The updated value.
     * @returns {Object} - The object containing the planned cost, rate and unit amount.
     */
    getCost: (column, value, updatedValue, isLocal, currency) => {
        let rateField = isLocal && currency ? 'rate_local' : 'rate';
        let plannedCostield = isLocal && currency ? 'planned_cost_local' : 'planned_cost';

        //Divide the units by 1000 if "Cost Method" string contains CPM (Ex. CPM, dCPM, etc.)
        let units = column === 'Unit Amount' ? updatedValue : value.unit_amount;
        // update the rate field based on the column or if cost method is flat
        let rate = (column === 'Rate' || (column === 'Planned Cost' && value.cost_method === 'Flat'))? updatedValue : value[rateField];
        let cost = column === 'Planned Cost' ? updatedValue : value[plannedCostield];
        let costMethod = value?.cost_method;
        let costValue =  PlacementUtils.getCostCalculation(units,rate,cost,costMethod,column);
        units = costValue.units;
        rate = costValue.rate;
        cost = costValue.cost;
        //Show a toast message if the "Units" field value contains a decimal point
        if(column === 'Rate' && (updatedValue?.toString().indexOf(".") > -1)){
            AlertMessagesService.showSuccessToastMessage(`Units is rounded down to the nearest whole number`);
        }
        const placementCost = { plannedCost: {amount: cost}, rate: {amount: rate}, unitAmount: Math.floor(units) };
        return placementCost;
    },

    /**
     * Function to calculate the total planned cost, unit amount, ad server fee and ad verification fee for each channel and site.
     * @param {Array} placementData - The placement data.
     * @returns {Object} - The object containing the total planned cost, unit amount, ad server fee and ad verification fee for each channel and site.
    */
     calculateTotalCostAndUnits : (placementData, vendorMappingMap, campaignObj) => {        
        let channelSiteMap = {};
        for(let i=0; i<placementData.length; i++){
            let placementType = placementData[i]?.planned_mapped_channel || placementData[i]?.placement_type || "Unassigned";
            let site = PlacementUtils.getSiteValue(placementData[i], campaignObj)?.toUpperCase();
            // Get the placement type and site name from Paramter code taxonomy schema and display if available else use placement type and site
            // if(placementData[i].parameter_code_taxonomy_schema && placementData[i].parameter_code_taxonomy_display){
                
                // for future reference, now we are getting channel from placementtype
                // let channel = PlacementUtils.getFieldValuefromParameterCode(placementData[i].parameter_code_taxonomy_schema, placementData[i].parameter_code_taxonomy_display, 'Buy Type');
                

                // if(!placementData[i]?.planned_mapped_channel && (!channel || channel === 'NU')) {
                //     placementType = 'Unassigned';
                // } else {
                    // placementType = placementData[i]?.planned_mapped_channel || channel;
                // }

                // placementType = placementData[i]?.planned_mapped_channel || placementData[i]?.placement_type || "Unassigned";

            // } else {
            // }
            // if(vendorMappingMap[site]){
            //     site = vendorMappingMap[site].planIt.toUpperCase();
            // }
            if(!channelSiteMap[placementType]){
                channelSiteMap[placementType] = {planned_cost: 0, planned_cost_local:0, unit_amount: 0, ad_server_fee: 0, ad_verification_fee: 0};
                channelSiteMap[placementType][site] = {planned_cost: 0, planned_cost_local:0, unit_amount: 0, ad_server_fee: 0, ad_verification_fee: 0};
                
                if(!['Child', 'DSP', 'Delivered', 'DirectCreative', 'ProgrammaticPlacement'].includes(placementData[i].package_type)){
                    channelSiteMap[placementType].planned_cost += placementData[i].planned_cost;
                    channelSiteMap[placementType].planned_cost_local += placementData[i].planned_cost_local;
                    channelSiteMap[placementType].unit_amount += placementData[i].unit_amount;
                    channelSiteMap[placementType].ad_server_fee += placementData[i].ad_server_fee;
                    // channelSiteMap[placementType].ad_server_fee_local += placementData[i].ad_server_fee_local;
                    channelSiteMap[placementType].ad_verification_fee += placementData[i].ad_verification_fee;
                    // channelSiteMap[placementType].ad_verification_fee_local += placementData[i].ad_verification_fee_local;

                    channelSiteMap[placementType][site].planned_cost += placementData[i].planned_cost;
                    channelSiteMap[placementType][site].planned_cost_local += placementData[i].planned_cost_local;
                    channelSiteMap[placementType][site].unit_amount += placementData[i].unit_amount;
                    channelSiteMap[placementType][site].ad_server_fee += placementData[i].ad_server_fee;
                    // channelSiteMap[placementType][site].ad_server_fee_local += placementData[i].ad_server_fee_local;
                    channelSiteMap[placementType][site].ad_verification_fee += placementData[i].ad_verification_fee;
                    // channelSiteMap[placementType][site].ad_verification_fee_local += placementData[i].ad_verification_fee_local;
                }
            } else {
                if(!channelSiteMap[placementType][site]){
                    channelSiteMap[placementType][site] = {planned_cost: 0, planned_cost_local:0, unit_amount: 0, ad_server_fee: 0, ad_verification_fee: 0};
                }
                if(!['Child', 'DSP', 'Delivered', 'DirectCreative', 'ProgrammaticPlacement'].includes(placementData[i].package_type)){
                    channelSiteMap[placementType].planned_cost += placementData[i].planned_cost;
                    channelSiteMap[placementType].planned_cost_local += placementData[i].planned_cost_local;
                    channelSiteMap[placementType].unit_amount += placementData[i].unit_amount;
                    channelSiteMap[placementType].ad_server_fee += placementData[i].ad_server_fee;
                    // channelSiteMap[placementType].ad_server_fee_local += placementData[i].ad_server_fee_local;
                    channelSiteMap[placementType].ad_verification_fee += placementData[i].ad_verification_fee;
                    // channelSiteMap[placementType].ad_verification_fee_local += placementData[i].ad_verification_fee_local;
                    
                    channelSiteMap[placementType][site].planned_cost += placementData[i].planned_cost;
                    channelSiteMap[placementType][site].planned_cost_local += placementData[i].planned_cost_local;
                    channelSiteMap[placementType][site].unit_amount += placementData[i].unit_amount;
                    channelSiteMap[placementType][site].ad_server_fee += placementData[i].ad_server_fee;
                    channelSiteMap[placementType][site].ad_server_fee_local += placementData[i].ad_server_fee_local;
                    channelSiteMap[placementType][site].ad_verification_fee += placementData[i].ad_verification_fee;
                    // channelSiteMap[placementType][site].ad_verification_fee_local += placementData[i].ad_verification_fee_local;
                }
            }
        }
        return channelSiteMap;
    },

    /**
     * Function to get the field value from the parameter code string based on the field name.
     * @param {String} parameterCodeSchema - The parameter code taxonomy schema.
     * @param {String} parameterCodeString - The parameter code taxonomy string.
     * @param {String} field - The field name.
     * @returns {String} - The field value.
     */ 
    getFieldValuefromParameterCode : (parameterCodeSchema, parameterCodeString, field) => {
        let fieldValue = '';
        if(parameterCodeSchema && parameterCodeString){
            let parameterCodeFieldIndex = parameterCodeSchema.split('|').indexOf(field);
            if(parameterCodeFieldIndex > -1){
                fieldValue = parameterCodeString.split('_')[parameterCodeFieldIndex];
            }
        }
        return fieldValue;
    },

    /**
     * Function to set the menu types & subtypes based on the channel and channel dropdown list.
     * It stores all the possible placement subtypes for each placement type along with its taxonomy type and taxonomy data.
     * Based on that it will create the Create Menu list for each channel.
     * @param {String} channel - The channel.
     * @param {Array} channelDropdownList - The channel dropdown list.
     * @returns {Object} - The object containing the menu types.
    */ 
    setMenuTypes : (channel, channelDropdownList, allTaxonomyData) => {
        let menuTypes =  structuredClone(placementCreateMenuTypes);
        
        // Remove the placement type from the menu types if the taxonomy data is not available
        if(!allTaxonomyData['directLineTaxonomyData']) delete menuTypes['Direct']['Line Item'];
        if(!allTaxonomyData['programmaticPlacementTaxonomyData']) delete menuTypes['Programmatic']['Placement'];
        if(!allTaxonomyData['socialDirectLineTaxonomyData']) delete menuTypes['Social Direct']['Line Item'];
        if(!allTaxonomyData['socialProgrammaticPlacementTaxonomyData']) delete menuTypes['Social Programmatic']['Placement'];

        switch(channel){
            case "Paid Social":
                channelDropdownList[0].submenu.push({
                    title: "Paid Social", type: "Paid Social", 
                    submenu: [{title: "Social Direct", type: "Social Direct", submenu: Object.values(menuTypes['Social Direct'])},
                    {title: "Social Programmatic", type: "Social Programmatic", submenu: Object.values(menuTypes['Social Programmatic'])}]});
                break;
            case "Paid Search":
                channelDropdownList[0].submenu.push(menuTypes['Paid Search']);
                break;
            case "Fee type":
                channelDropdownList[0].submenu.push(menuTypes['Fee type']);
                break; 
            case "Print":
                channelDropdownList[0].submenu.push({title: "Print", type: "Print", submenu: Object.values(menuTypes['Print'])});
                break;
            case "OOH":
                channelDropdownList[0].submenu.push({title: "OOH", type: "OOH", submenu: Object.values(menuTypes['OOH'])});
                break;
            case "Cinema":
                channelDropdownList[0].submenu.push({title: "Cinema", type: "Cinema", submenu: Object.values(menuTypes['Cinema'])});
                break;  
            case "Other":
                channelDropdownList[0].submenu.push({title: "Other", type: "Other", submenu: Object.values(menuTypes['Other'])});
                break;
            case "Unallocated":
                channelDropdownList[0].submenu.push({ title: "Unallocated", type: "Unallocated", submenu: Object.values(menuTypes['Unallocated']) });
                break;
            case "National TV":
                channelDropdownList[0].submenu.push({ title: "National TV", type: "National TV", submenu: Object.values(menuTypes['National TV']) });
                break;
            case "Network Radio":
                channelDropdownList[0].submenu.push({ title: "Network Radio", type: "Network Radio", submenu: Object.values(menuTypes['Network Radio']) });
                break;
            case "Spot TV":
                channelDropdownList[0].submenu.push({ title: "Spot TV", type: "Spot TV", submenu: Object.values(menuTypes['Spot TV']) });
                break;
            case "Spot Radio":
                channelDropdownList[0].submenu.push({ title: "Spot Radio", type: "Spot Radio", submenu: Object.values(menuTypes['Spot Radio']) });
                break;
            default:
                channelDropdownList[0].submenu.push({
                    title: channel, type: channel, 
                    submenu: [{title: "Direct", type: "Direct", submenu: Object.values(menuTypes['Direct'])},
                    {title: "Programmatic", type: "Programmatic", submenu: Object.values(menuTypes['Programmatic'])}]});
                break;    
        }
        channelDropdownList[0].submenu[channelDropdownList[0].submenu.length - 1].channel = channel;
    },

    /**
     * Map placement type to the specified menu type to retreived the correct taxonomy data
     * @param {string} packageType - the package type
     * @param {string} placementType - the placement type
     * @param {string} parentType - the parent type
     * @returns {object} - the mapped package type
    */ 
    mapPackageType: (packageType, placementType, parentType) => {
        let isSocial = ["Social", "Paid Social"].includes(placementType);
        let menuTypes =  structuredClone(placementCreateMenuTypes);
        let packageTypeMap = {
            "Package": {title: "Package",type: isSocial ? "Social Direct": "Direct"},
            "DirectLine": {title: "Line Item",type: isSocial ? "Social Direct": "Direct"},
            "ProgrammaticPackage" : {title: "Package",type: isSocial ? "Social Programmatic": "Programmatic"},
            "ProgrammaticPlacement" : {title: "Placement",type: isSocial ? "Social Programmatic": "Programmatic"},
            "DSP" : {title: "Line Item",type: isSocial ? "Social Programmatic": "Programmatic"},
            "Child" : parentType === 'DSP' ? {title: "Creative Placement",type: isSocial ? "Social Programmatic": "Programmatic"} : {title: "Placement",type: isSocial ? "Social Direct": "Direct"},
            "Standalone": {title: "Placement",type: isSocial ? "Social Direct": "Direct"},
            "DirectCreative": {title: "Creative Placement",type: isSocial ? "Social Direct": "Direct"},
            "FeeOrder": {title: "Fee type",type: "Fee"},
            "SearchOrder": {title: "Paid Search",type: "Search"},
            "DoohPackage": {title: "DOOH Package",type: "OOH"},
            "DoohPlacement": {title: "DOOH Placement",type: "OOH"},
        }
        // For Offline Packages & Placements
        if(packageType && !packageTypeMap[packageType]){
            if(packageType.includes('OfflinePackage') || packageType.includes('NetworkPackage')){
                packageTypeMap[packageType] = menuTypes[placementType]['Offline Package'];
            } else if(packageType.includes('EstimateName')){
                packageTypeMap[packageType] = menuTypes[placementType]['Offline Estimate Name'];
            }
        }
        return packageTypeMap[packageType];
    },

    /**
    * This function returns the edit placement taxonomy schema data based on the placement type.
    * @param placement - The placement parameter is used to get the package type of the placement.
    * @param placementKey - The placementKey parameter is used to check if package type is "Child" or not.
    * @returns {array} - edit placement taxonomy schema array
    */
    getPlacementPopupField(placement, placementKey,state,placementTaxonomyMap,allTaxonomyData) {
        let editPackageData= {};
        if(placementKey === 'placement_taxonomy'){
            let taxonomyData = PlacementUtils.getDialogTaxonomyData(state, PlacementUtils.mapPackageType(placement.package_type, placement.placement_type, placement.parent_type),placementTaxonomyMap, allTaxonomyData);
            editPackageData = taxonomyData ? PlacementUtils.mapDropdownValues(taxonomyData) : [];
        }else{
            editPackageData = PlacementUtils.mapDropdownValues(allTaxonomyData.defaultTaxonomyData);
        }
        return editPackageData;
    },

    /**
    * Retrieves the appropriate taxonomy data based on the provided package or based on the programmaticType.
    * @param {object} state - The state object.
    * @param {string} map - Object containing the package title & type.
    * @param {object} placementTaxonomyMap - Object containing the taxonomy data for each placement type.
    * @param {object} allTaxonomyData - Object containing all the taxonomy data.
    * @returns {object} The taxonomy data corresponding to the placement type
    */
     getDialogTaxonomyData : (state, map, placementTaxonomyMap, allTaxonomyData) => {
        if(state?.editDailog && state?.placementData?.override_taxonomy && !state?.placementData?.overriden_placement_taxonomy){
            return null;
        }
        if(map){
            return placementTaxonomyMap[map.title] ? placementTaxonomyMap[map.title][map.type]: null;
        } else {
            if(state?.programmaticType && state?.programmaticMainType){
                return placementTaxonomyMap[state?.programmaticType][state?.programmaticMainType];
            } else {
                return allTaxonomyData.defaultTaxonomyData
            }
        }
    },

    /**
     * Maps the dropdown values for the taxonomy fields
     * @param {object} taxonomyData - The taxonomy data for the placement type
     * @returns {array} The dropdown values for the taxonomy fields
    */ 
    mapDropdownValues : (taxonomyData, includeHidden = false) => {
        return taxonomyData?.fields?.reduce((filterData, field) => {
            const allCondtion = field?.hidden ? includeHidden : true;
            if(allCondtion){
                let option =  {
                    alias: field?.alias,
                    name: field?.name,
                    id: field?.id,
                    dateFormat: field?.dateFormat ? field?.dateFormat : null,
                    field_type: field?.field_type,
                    delimiterValue:field?.delimiter_value,
                    isExplicitCascading: field?.isExplicitCascading,
                    hidden: field?.hidden,
                    taxonomyTextcase: taxonomyData?.taxonomyTextcase,
                    //condtion is to check if field_type !== 2 (2 is for input box),it dont need fielditems values
                    dropDownValues: field?.field_type !== 2? field?.fielditems.map(item => ({
                        label: item.name,
                        value: item.code,
                        id: item.id
                    })) : []
                }
                filterData.push(option);
            }
            return filterData;
        }, []);
    },

    /**
     * The below code sets the page number and paginated data based on the results data.
     * @param {Object} placementContext - The placement component context.
     * @param {Object} results - The results data.
     * @param {boolean} isMount - A boolean value that indicates whether the component is mounted.
     * @param {Object} filterObj - An object that contains the filter values.
     * @returns {Array<Object>} paginatedData - The paginated data.
    */ 
    setPageNoAndPaginatedData: (placementContext, results, isMount, filterObj) => {
        let currentPage = 0;
        let paginatedData = [];
        let paginatedDataLength = 0;
        // If the component is mounted and there is no supplier name in the URL or the supplier row ID is already set or there is a filter object, set the page number to 0 and the paginatedDataLength to the length of the results data
        if((isMount && (!placementContext.props.params?.supplierName || placementContext.routedSupplierRowId)) || filterObj){  
            placementContext.pageNo = 0;
            paginatedDataLength = results.data.length;
        // If the component is first time mounted and there is a supplier name in the URL, set the page number & paginatedDataLength to the length of the results data
        } else if(isMount && placementContext.props.params?.supplierName){ 
            placementContext.pageNo = results.data.length;
            paginatedDataLength = results.data.length
        } else {
        // If not mounted and the page number is greater than the length of the results data, set the page number to the length of the results data and the paginatedDataLength to the page number 
            if(placementContext.pageNo > results.data.length){ 
                placementContext.pageNo = results.data.length;
                paginatedDataLength = placementContext.pageNo;
        // If the page number is less than the length of the results data, set the paginatedDataLength to the page number and set PageNo to the length of the results data if result data is less than 10         
            } else if(placementContext.pageNo < results.data.length){  
                if(results.data.length > 30) {
                    paginatedDataLength = placementContext.pageNo;
                } else {
                    placementContext.pageNo = results.data.length;
                    paginatedDataLength = placementContext.pageNo;
                }
        // If the page number is equal to the length of the results data, set the paginatedDataLength to the page number        
            } else{ 
                paginatedDataLength = placementContext.pageNo;
            }
        }
        for(let i = 0; i < paginatedDataLength; i++) {
            paginatedData.push(results.data[i]);
            // If the component is mounted and there is no supplier name in the URL or the supplier row ID is already set or there is a filter object, increment the current page number & current page by 1, and break the loop if the current page is greater than or equal to 10
            if((isMount && (!placementContext.props.params?.supplierName || placementContext.routedSupplierRowId)) || filterObj){
                placementContext.pageNo++;
                currentPage++;
                if(currentPage >= 30) break;
            }
        }
        return paginatedData;
    },

    /**
     * Function to calculate the Billable rate, Billable, Margin and Markup% based on the data type and value.
     * @param {Object} formDataObj - The form data object.
     * @param {String} dataType - The data type.
     * @param {Number} value - The value.
     * @returns {Object} - The updated form data object.
    */ 
    calculateMarkup: (formDataObj, dataType, value) => {
        let formData = { ...formDataObj };
        formData['Planned Cost'] = Number(formData['Planned Cost'])
        formData[dataType] = Number(value);
        if(dataType === 'billableRate'){
            formData['billable'] = formData['billableRate'] * formData['Unit Amount'];
            formData['margin'] = formData['billable'] - formData['Planned Cost'];
            formData['markupPercent'] = (formData['billable'] - formData['Planned Cost']) / formData['Planned Cost'] * 100;
        } else if(dataType === 'billable'){
            formData['billableRate'] = formData['billable'] / formData['Unit Amount'];
            formData['margin'] = formData['billable'] - formData['Planned Cost'];
            formData['markupPercent'] = (formData['billable'] - formData['Planned Cost']) / formData['Planned Cost'] * 100;
        } else if(dataType === 'margin'){
            formData['billable'] = formData['Planned Cost'] + formData['margin'];
            formData['billableRate'] = formData['billable'] / formData['Unit Amount'];
            formData['markupPercent'] = (formData['billable'] - formData['Planned Cost']) / formData['Planned Cost'] * 100;
            // If billable or billable rate is negative then show error message
            if(formData['billable'] < 0 || formData['billableRate'] < 0){
                AlertMessagesService.showErrorToastMessage("Billable/Billable Rate cannot be negative, please enter margin accordingly");
                return;
            }
        } else if(dataType === 'markupPercent'){
            formData['billable'] = formData['Planned Cost'] + (formData['Planned Cost'] * formData['markupPercent'] / 100);
            formData['billableRate'] = formData['billable'] / formData['Unit Amount'];
            formData['margin'] = formData['billable'] - formData['Planned Cost'];
            // If billable or billable rate is negative then show error message
            if(formData['billable'] < 0 || formData['billableRate'] < 0){
                AlertMessagesService.showErrorToastMessage("Billable/Billable Rate cannot be negative, please enter markup% accordingly");
                return;
            }
        }
        return formData;
    },

    /**
     * function to find parent placement by using id from array list
     * @param {Array} placementArray 
     * @param {object} parendId 
     * @returns return parent placement
     */
    findMainParent:(placementArray,parendId)=>{
        let parentPlacementId = placementArray[parendId]?.parent_id;
        let value = placementArray[parendId];
        if(parentPlacementId){
            value = PlacementUtils.findMainParent(placementArray,parentPlacementId);
        }
        return value;
    },

    /**
     * Function is find value for drop down as , drop down accept only id and value;
     * it filter the value from option list and return slected value;
     * @param {string} fieldName 
     * @param {object} selectedDDValue 
     * @param {Array} validOptions 
     * @param {string} ddValue 
     * @returns return selected vaue from option list, or create selected value for drop down
     */
    getDropDownValue:(fieldName,selectedDDValue,validOptions,ddValue)=>{
        let value = []
        if((selectedDDValue?.value && selectedDDValue?.name === fieldName) ){
            value = validOptions.filter(item => item.id === selectedDDValue.value);
            if(!value.length){
                value = [{id:selectedDDValue.value, value:selectedDDValue.label, option_id:selectedDDValue.option_id}];
            }
        }else if(ddValue){
            value = validOptions.filter(item => item.id === ddValue);
            if(!value.length){
                value = [{id:ddValue, value:ddValue}]
            }
        }
        return value;
    },

    /**
     * Checking if creative schema is availabel
     * @param {object} placementObject placement detail
     * @returns boolean true or false.
     */
    checkCreativeTaxonomy:(placementObject,allTaxonomyData)=>{
        if(placementObject?.isOverride){
            return true;
        }
        if(placementObject?.programmaticType === 'Line Item' && allTaxonomyData['creativePackageTaxonomyData']){
            return allTaxonomyData['creativePackageTaxonomyData'].fields?.length ? true : false
        }else if(placementObject?.programmaticType === 'Social Line Item' && allTaxonomyData['socialProgrammaticCreativeTaxonomyData']){
           return allTaxonomyData['socialProgrammaticCreativeTaxonomyData'].fields?.length ? true : false
        }
        return false;
    }
,

    /**
     * getDropdownValues function retrieves valid dropdown values for a given field name, package type, placement key, schema array, and value array.
     * @param {string} fieldName - The name of the field for which dropdown values are to be retrieved.
     * @param {string} placementKey - The placement key, either "placement_taxonomy" or other.
     * @param {Array} schemaArr - An array containing schema names.
     * @param {Array} valueArr - An array containing corresponding values for the schema.
     * @param {Object} placement - The placement object.
     * @returns {Object} - An object containing dropdown values (ddValues) for the field, and validOptions, which are the filtered dropdown options based on the provided schema and value.
     */
    getDropdownValues:(fieldName,placementKey,schemaArr, valueArr, placement,placementTaxonomy,defaultTaxonomy=null,inclideHidden)=> {
        let matchedField ,validOptions, taxonomyData, parentField = null;
        let allTaxonomyFields, allSchemaArray, allValueArray = [];

        let placementSchemaArray = PlacementUtils.mapDropdownValues(placementTaxonomy,inclideHidden);
        let defaultSchemaArray = {};
        if(defaultTaxonomy?.fields?.length){
            defaultSchemaArray = PlacementUtils.mapDropdownValues(defaultTaxonomy,inclideHidden);
        }

        if(placementTaxonomy && placementTaxonomy?.fields.length && placementKey === 'placement_taxonomy'){
            allTaxonomyFields = defaultTaxonomy?.fields?.concat(placementTaxonomy?.fields);
        }else if(defaultTaxonomy?.fields.length && placementKey === 'parameter_code'){
            allTaxonomyFields = defaultTaxonomy.fields;
        }else{
            allTaxonomyFields = placementTaxonomy.fields;
        }
        let synthecticDelimiter = placementKey === 'parameter_code' ? null :":|";
        let pacementSchema = '';
        let parameterSchema = '';
        if(placementKey === 'placement_taxonomy'){
            allValueArray = PlacementDetailsTableService.splitStringIntoArray(placement[placementKey],placementSchemaArray,synthecticDelimiter,false,false,placement).nameArr.concat
            (PlacementDetailsTableService.splitStringIntoArray(placement.parameter_code,defaultSchemaArray).nameArr);
            pacementSchema = placement?.taxonomy_schema || placement['Placement Schema']
            parameterSchema = placement?.parameter_code_taxonomy_schema || placement['Parameter Code Schema'];
            allSchemaArray = pacementSchema?.split('|').concat(parameterSchema?.split('|'));
            
        }else{
            allValueArray = PlacementDetailsTableService.splitStringIntoArray(placement[placementKey],placementSchemaArray,synthecticDelimiter,false,false,placement).nameArr;
            allSchemaArray = schemaArr;
        }


        if(placementKey === 'parameter_code'){
            // Retrieve taxonomy data based on package type.
            taxonomyData = defaultTaxonomy;
            matchedField = defaultSchemaArray.find((obj) => obj.name === fieldName);
        } else{
            taxonomyData = placementTaxonomy;
            matchedField = placementSchemaArray.find((obj) => obj.name === fieldName);
        }
        let ddValues = matchedField?.dropDownValues.map(val=> val? {id:val.value,value:val.label,option_id:val.id}:[]);

        if((matchedField?.dropDownValues || []).length > 0 && taxonomyData){
            let currentFieldId = matchedField.id;
            parentField = PlacementUtils.CheckingCascadingValues(allTaxonomyFields,currentFieldId);
            if(parentField){  
                validOptions = PlacementUtils.findValidOption(allSchemaArray ? allSchemaArray : schemaArr,allValueArray ? allValueArray : valueArr,parentField.fielditems,currentFieldId,parentField,ddValues);
           }
        }

        if(!validOptions){
            validOptions = parentField && matchedField.isExplicitCascading ? [] : ddValues;
        }
       return {ddValues : ddValues ,validOptions:validOptions, field: matchedField, parentField};
    },
    
    /**
     * Checking if selected option have cascading values
     * @param {Array} fields 
     * @param {number} currentFieldId 
     * @returns return field that matched with selected filed id 
     */
    CheckingCascadingValues:(fields,currentFieldId)=>{
            let parentField = null;
            for(let field of fields){
                let childFieldIArr = [];
                for(let fieldItem of field?.fielditems){
                    if(fieldItem.childitems?.length > 0){
                        childFieldIArr = fieldItem.childitems.map((chObj) => Number(chObj.FieldId));
                        childFieldIArr = [...new Set(childFieldIArr)];
                        if(childFieldIArr.includes(currentFieldId)){
                            parentField = field;
                            break;
                        }
                    }                     
                }
                if(parentField) break;
            }
        return parentField;
    },

    /**
     * find all valid value from list that are cascading to selected field
     * @param {Array} schemaArr 
     * @param {Array} valueArr 
     * @param {Array} fielditems 
     * @param {number} currentFieldId 
     * @param {object} parentField 
     * @returns if match field are ther return all match field in array
     */
    findValidOption:(schemaArr,valueArr,fielditems,currentFieldId,parentField,ddValues)=>{
        let schemIndex = schemaArr.indexOf(parentField.name);
        let fieldValue = valueArr[schemIndex];
        let validOptionCodes = [];
        let validOptions = null;
        for(let fieldItem of fielditems){
            if(fieldItem.code === fieldValue){
                fieldItem.childitems.map((chObj) => {
                    if (currentFieldId === Number(chObj.FieldId)){
                        validOptionCodes.push(chObj.Code)
                    }
                });
                break;
            }
        }
        if(validOptionCodes.length){
            validOptions = ddValues.filter(dropDown => validOptionCodes.includes(dropDown.id));
        }
        return validOptions;
    },

    /**
     * Function to populate the explicit cascading map based on the taxonomy data
     * @param {String} taxonomyData - The taxonomy data.
     * @param {String} cascadingMap - The cascading map.
    */ 
    populateExplicitCascadingMap: (taxonomyData, cascadingMap) => {
        taxonomyData?.fields?.forEach((field) => {
            cascadingMap[Number(field.id)] = [];
            if (field?.fielditems?.length) {
                field.fielditems.forEach((item) => {
                    if (item?.childitems?.length) {
                        item.childitems.forEach((childItem) => {
                            if (!cascadingMap[Number(field.id)].includes(Number(childItem.FieldId))) {
                                cascadingMap[Number(field.id)].push(Number(childItem.FieldId));
                            }
                        });
                    }
                });
            }
            if (!cascadingMap[Number(field.id)].length) {
                delete cascadingMap[Number(field.id)];
            }
        });
    },

    /**
     * Function to get all the child of a programmatic placement
     * @param {Object} parentPlacement - The parent placement.
     * @param {Array} allPlacement - The all placement data of a programmatic package provider.
     * @returns {Array} - The array containing all the child placements of a programmatic placement.
    */
    getAllProgrammaticChild: (parentPlacement, allPlacement)=>{
        let programmaticChild = [];
        let findChild = (parentPlacement, allPlacement) => {
            let child = allPlacement?.filter(placement => placement.parent_id && Number(placement.parent_id) === Number(parentPlacement.id));
            if(child?.length){
                programmaticChild = programmaticChild.concat(child);
                for(let i=0; i<child.length; i++){
                    findChild(child[i], allPlacement);
                }
            }
        }
        findChild(parentPlacement, allPlacement);
        return programmaticChild;
    },

    /**
     * function is get taxonomy values, split both name into array
     * split array values will compare into diffrent function
     * return array of object with name ,color and delimeter in array of object
     * @param {object} state 
     * @param {Map} placementTaxonomyMap 
     * @param {Map} allTaxonomyData 
     * @param {object} firstPlacement 
     * @param {object} secondPlacement 
     * @param {boolean} isPlacement 
     * @returns it will retun array of object
     */
    getPlacementTaxonomyValuesAndNames:(state,placementTaxonomyMap,allTaxonomyData,firstPlacement,secondPlacement,isPlacement)=>{
        let taxonomyData = {}
        let taxonmyField = [];
        let synthecticDelimiter = '';
        let firstName = '';
        let secondName = '';
        if(isPlacement){
            taxonomyData = PlacementUtils.getDialogTaxonomyData(state, PlacementUtils.mapPackageType(firstPlacement.package_type, firstPlacement.placement_type, firstPlacement.parent_type), placementTaxonomyMap, allTaxonomyData);  
            synthecticDelimiter = ':|'
            firstName = firstPlacement.placement_taxonomy;
            secondName = secondPlacement.placement_taxonomy;
        }else{
            taxonomyData = allTaxonomyData.defaultTaxonomyData;
            firstName = firstPlacement.parameter_code;
            secondName = secondPlacement.parameter_code;
        }
        taxonmyField = taxonomyData ? PlacementUtils.mapDropdownValues(taxonomyData) : [];
        
        let placementObject = PlacementDetailsTableService.splitStringIntoArray(firstName,taxonmyField, synthecticDelimiter,false,true, firstPlacement);
        let firstPlacementNameArr = placementObject.nameArr;
        
        let secondPlacementObject = PlacementDetailsTableService.splitStringIntoArray(secondName,taxonmyField, synthecticDelimiter,false,true, secondPlacement); 
        let secondPlacementNameArr = secondPlacementObject.nameArr;
        let placementDetails ={}
        //if overide just compare string and assign color
        if(firstPlacement?.override_taxonomy){
            let color = firstName === secondName ? '' : 'var(--text-error)';
            let placementName = [{
                name: firstName,
                color: color,
                delimiterValue: ''
            }];
            let secondPlacementName = [{
                name: secondName,
                color: color,
                delimiterValue: ''
            }];
            return {firstName:placementName, secondName:secondPlacementName};
        }else{
            placementDetails = PlacementUtils.compareNames(taxonmyField, firstPlacementNameArr, secondPlacementNameArr);
        }
        
        if(isPlacement){
            placementDetails.firstName.push({name:placementObject.syntheticId});
            placementDetails.secondName.push({name:secondPlacementObject.syntheticId});
        }
        return placementDetails;
    },

    /** 
     * function will recive name in array
     * all name will be compare one by one ,
     * return array of object with name ,color and delimeter in array of object
     * @param {*} taxonmyField 
     * @param {*} firstNameArr 
     * @param {*} secondNameArr 
     * @returns 
     */
    compareNames:(taxonmyField, firstNameArr, secondNameArr)=>{
        let placementName = [];
        let secondPlacementName = [];
        taxonmyField.forEach((value,index)=>{
            let delimiter = taxonmyField.length -1 == index ? '' : value?.delimiterValue;
            let color = '';
            
            // Get the values with fallback to prevent undefined
            let firstName = firstNameArr[index] !== undefined ? firstNameArr[index] : 'NU';
            let secondName = secondNameArr[index] !== undefined ? secondNameArr[index] : 'NU';
            
            if(firstName !== secondName){
                color = 'var(--text-error)';
            }
            placementName.push({
                name: firstName,
                color: color,
                delimiterValue: delimiter
            });
            secondPlacementName.push({
                name: secondName,
                color: color,
                delimiterValue: delimiter
            });
        });
        return {firstName:placementName, secondName:secondPlacementName}
    },

    /**
     * Function to get the respective field name based on the MO error code
     * @param {String} moErrorField - The MO error field.
     * @returns {String} - The field name.
    */ 
    getMOErrorFields: (moErrorField) => {
        let fieldMap = {
            'Buy type': 'Buy Type',
            'Buy category': 'Buy Category',
            'dimensions': 'Dimensions',
            'costMethod': 'Cost Method',
            'unitType': 'Unit Type'
        }
        return fieldMap[moErrorField.trim()] ? fieldMap[moErrorField.trim()] : moErrorField
    },

    generateRandomId: () => {
        return `.${Math.floor(Math.random() * 1000000000)}`;
    },

    CreateNestedData: (input, vendorMappingMap, isLocal = false, channelSiteMap, campaignObj) => {
        const itemMap = {}; // Stores all items by ID for quick lookup
        const rootItems = []; // Stores top-level items
        const typeSiteMap = {}; // Maps placement_type and site to assigned random IDs
    
        // Create a map of all items by their ID
        input.forEach(item => {
            if (item?.data_source === 'planit') {
                item['id'] = PlacementUtils.generateRandomId(); // generate random id's for planit data as they don't have id's
            }

            if(["Child", "DirectCreative", "Delivered", "EstimateName"].includes(item?.package_type)){
                item['parent_type'] = itemMap[item?.parent_id]?.package_type;
             }

            // if(vendorMappingMap[item.site]){
            //     item['site'] = vendorMappingMap[item.site].planIt.toUpperCase();
            // }

            itemMap[item.id] = { ...item, nestedData: [] };
        });
    
        // Attach items to their parents or root if no parent_id exists
        input.forEach(item => {
            if (item.parent_id && itemMap[item.parent_id]) {
                itemMap[item.parent_id].nestedData.push(itemMap[item.id]);
            } else {
                rootItems.push(itemMap[item.id]);
            }
        });
    
        // Group by planned_mapped_channel or placement_type and site
        rootItems.forEach(item => {
            const placementType = item?.planned_mapped_channel || item?.placement_type || "Unassigned";
            const site = PlacementUtils.getSiteValue(item, campaignObj)?.toUpperCase();

            // Ensure unique random IDs for each planned_mapped_channel or placement_type and site combination
            if (!typeSiteMap[placementType]) {
                typeSiteMap[placementType] = { id: PlacementUtils.generateRandomId(), sites: {} };
            }
            if (!typeSiteMap[placementType].sites[site]) {
                typeSiteMap[placementType].sites[site] = { id: PlacementUtils.generateRandomId(), nestedData: [] };
            }
    
            // Push item under the correct site
            typeSiteMap[placementType].sites[site].nestedData.push(item);
        });
        
        // Convert grouped data into the final nested format
        return Object.entries(typeSiteMap).map(([placementType, { id: typeId, sites }]) => ({
            placement_taxonomy: placementType,
            id: typeId,
            title: 'Channel',
            unit_amount: channelSiteMap[placementType]?.unit_amount,
            planned_cost: channelSiteMap[placementType]?.planned_cost,
            planned_cost_local: channelSiteMap[placementType]?.planned_cost_local,
            nestedData: Object.entries(sites).map(([site, { id: siteId, nestedData }]) => ({
                unit_amount: channelSiteMap[placementType]?.[site]?.unit_amount,
                planned_cost: channelSiteMap[placementType]?.[site]?.planned_cost,
                planned_cost_local: channelSiteMap[placementType]?.[site]?.planned_cost_local,
                placement_taxonomy: site,
                channel: placementType,
                id: siteId,
                nestedData,
                title: 'Publisher',
            })),
        }));
    },

    mergeChannelsAndPublishers: (placementWithNestedStructure, emptyChannelsAndPublishers) => {
        // Create a copy of the placementWithNestedStructure array
        const mergedData = [...placementWithNestedStructure];
    
        // Iterate over each empty channel in the emptyChannelsAndPublishers array
        emptyChannelsAndPublishers.forEach((emptyChannel) => {
            // Find an existing channel in the mergedData array that matches the placement_taxonomy of the empty channel
            const existingChannel = mergedData.find(
                (channel) => channel.placement_taxonomy === emptyChannel.placement_taxonomy
            );
    
            // If an existing channel is found
            if (existingChannel) {
                // Iterate over each empty publisher in the nestedData of the empty channel
                emptyChannel.nestedData.forEach((emptyPublisher) => {
                    // Check if the publisher already exists in the nestedData of the existing channel
                    const existingPublisher = existingChannel.nestedData.find(
                        (publisher) => publisher.placement_taxonomy === emptyPublisher.placement_taxonomy
                    );
    
                    // If the publisher does not exist, add it to the nestedData of the existing channel
                    if (!existingPublisher) {
                        existingChannel.nestedData.push({
                            ...emptyPublisher,
                            id: `random-${PlacementUtils.generateRandomId()}`, // Generate a random ID for the new publisher
                        });
                    }
                });
            } else {
                // If no existing channel is found, add the empty channel to the mergedData array
                mergedData.push({
                    ...emptyChannel,
                    id: `random-${PlacementUtils.generateRandomId()}`, // Generate a random ID for the new channel
                });
            }
        });
    
        // Return the merged data
        return mergedData;
    },

    /**
     * Set channel data in object from campaign
     * @param {object} campaignObj 
     * @returns object with channel detail
     */
    setChannelData : (campaignObj) => {
        let channelData = [];
        campaignObj?.channels.forEach((channel)=>{
            let channelObj = {
                name: channel.channel_name,
                budget: channel.channel_total_budget,
                adverification: 0,
                adserving: 0,
                suppliers: []
            }
            channel.publishers.forEach((publisher)=>{
                if(publisher.publisher_type === 'Ad Serving')
                    channelObj.adserving+= publisher.publisher_budget;
                if(publisher.publisher_type === 'Ad Verification')
                    channelObj.adverification+= publisher.publisher_budget;   

                channelObj.suppliers.push({
                    name: publisher.publisher_name,
                    budget: publisher.publisher_budget,
                    suppliertype: publisher.publisher_type
                })     
            })
            channelData.push(channelObj);
        });
        return channelData;
    },

    /**
     * Returns a display-friendly string for the placement type based on the provided package type, placement type, and parent type.
     * This function maps various package types and placement types to their corresponding display values.
     *
     * @param {Object} value - The object containing details about the placement.
     * @param {string} value.package_type - The type of the package (e.g., 'Package', 'Child', 'DirectLine').
     * @param {string} value.placement_type - The type of the placement (e.g., 'Social', 'Direct').
     * @param {string} [value.parent_type] - The type of the parent placement (e.g., 'DSP').
     * @returns {string} - The display-friendly string for the placement type.
     */
    getPlacementTypeDisplayValue: (value) => {
        if (value?.package_type === 'Package') {
            return value?.placement_type === 'Paid Social' ? 'Social Direct Package' : 'Direct Package';
        } else if (value?.package_type === 'Child' && value?.parent_type !== 'DSP') {
            return value?.placement_type === 'Paid Social' ? 'Social Direct Placement' : 'Direct Placement';
        } else if (value?.package_type === 'DirectLine') {
            return value?.placement_type === 'Paid Social' ? 'Social Direct Line (Ad Set)' : 'Direct Line';
        } else if (value?.package_type === 'DirectCreative') {
            return value?.placement_type === 'Paid Social' ? 'Social Direct Creative (Ad Name)' : 'Direct Creative';
        } else if (value?.package_type === 'ProgrammaticPackage') {
            return value?.placement_type === 'Paid Social' ? 'Social Programmatic Package' : 'Programmatic Package';
        } else if (value?.package_type === 'ProgrammaticPlacement') {
            return value?.placement_type === 'Paid Social' ? 'Social Programmatic Placement' : 'Programmatic Placement';
        } else if (value?.package_type === 'DSP') {
            return value?.placement_type === 'Paid Social' ? 'Social Programmatic Line (Ad Set)' : 'Programmatic Line';
        } else if (value?.package_type === 'Child' && value?.parent_type === 'DSP') {
            return value?.placement_type === 'Paid Social' ? 'Social Programmatic Creative (Ad Name)' : 'Programmatic Creative';
        } else if (value?.package_type === 'Delivered') {
            return 'Creative'; // all delivered data are treated as creative, subject to change
        } else if (value?.package_type === 'Standalone') {
            return value?.placement_type === 'Paid Social' ? 'Social Direct Standalone' : 'Direct Standalone';
        } else if (value?.package_type === 'OfflinePackage') {
            return 'Offline Package';
        } else if (value?.package_type === 'OfflineEstimateName') {
            return 'Offline Estimate Name';
        } else if (['NationalTVNetworkPackage'].includes(value?.package_type)) {
            return 'Network Package';
        } else if (['NationalTVNetworkEstimateName'].includes(value?.package_type)) {
            return 'Network Estimate Name';
        } else if (['DoohPackage'].includes(value?.package_type)) {
            return 'DOOH Package';
        } else if (['DoohPlacement'].includes(value?.package_type)) {
            return 'DOOH Placement';
        } else {
            return value?.package_type;
        }
    },

      /**
     * Converts a date object or string into a formatted date string (YYYY-MM-DD).
     * If the input is not a valid date, it returns an empty string.
     *
     * @param {Date|string} dateObj - The date object or string to be converted.
     * @returns {string} - The formatted date string in the format 'YYYY-MM-DD', or an empty string if the input is invalid.
     */
      getDateString: (dateObj) => {
        if (dateObj) {
            if (typeof(dateObj) !== 'object') {
                dateObj = new Date(dateObj);
            }
            const year = dateObj.getFullYear();
            const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Add leading zero
            const day = String(dateObj.getDate()).padStart(2, '0'); // Add leading zero
            return `${year}-${month}-${day}`;
        } else {
            return '';
        }
      },

      parseDate: (dateString) => {
        if (!dateString) return null;
    
        const [year, month, day] = dateString.split('-').map((val, index) =>
            index === 1 ? parseInt(val, 10) - 1 : parseInt(val, 10)
        );
    
        return new Date(year, month, day);
    },

    /**
     * Creates an array of JSON objects representing the selected taxonomy values.
     * @param {Object} formData - The form data containing field values.
     * @param {Array} taxonomyData - The taxonomy metadata.
     * @returns {Array} An array of JSON objects representing the selected taxonomy values.
     */
    createNames: (formData, taxonomyData,addNull = false) => {
        let taxonomySelectedValueJson = [];
        let caseType = taxonomyData?.taxonomyTextcase || 'no_case';
        taxonomyData?.fields?.forEach((field, index) => {
            const fieldValue = formData[field.name] || formData[field.alias] ;
            if(fieldValue || field.field_type === 10){
                let fieldItems = field?.fielditems || field?.dropDownValues;
                let selectedOption = fieldItems?.find(val=>val.code === fieldValue);
                let displayName = selectedOption?.name ? selectedOption.name : fieldValue;
                let jsonObj = PlacementUtils.createJsonFromTaxonomy(fieldValue, field, displayName,caseType);
                taxonomySelectedValueJson.push(jsonObj);
            }
            else if(!fieldValue && !field.mandatory){
                // If field type is 10, we use the fieldValue as the code and displayName
                let jsonObj = PlacementUtils.createJsonFromTaxonomy('', field, '',caseType);
                taxonomySelectedValueJson.push(jsonObj);

            }else if(addNull){
                let jsonObj = PlacementUtils.createJsonFromTaxonomy('NU', field, 'NU',caseType);
                taxonomySelectedValueJson.push(jsonObj);
            }
        });        
        return { taxonomySelectedValueJson };
    },

    /**
     * Creates a JSON object from the given field value, field metadata, and selected option.
     * @param {*} fieldValue - The value of the field.
     * @param {*} field - The field metadata.
     * @param {*} selectedOption - The selected option from the field's items.
     * @returns {Object} The created JSON object.
     */
    createJsonFromTaxonomy: (fieldValue, field, displayName,caseType) => {
        if(field.field_type == 10){
            fieldValue = fieldValue ? fieldValue : "{TaxonomyValueID}";
            displayName = fieldValue ? fieldValue : "{TaxonomyValueID}";
        }else{
            //(name,field_name,hidden) will remove it before sending in payload
            displayName = PlacementUtils.transformValueToGivenCase(displayName,caseType);
            fieldValue = PlacementUtils.transformValueToGivenCase(fieldValue,caseType);
        }
        return {
            name : displayName,
            field_name: field.name || field.alias,
            id : field.id,
            code :  fieldValue,
            delimiter : field?.delimiterValue || field?.delimiter_value,
            hidden : field?.hidden
        }
    },
    /**
     * Transforms a string value to the specified case type (lowercase, uppercase, or no_case)
     * @param {string} value - The string value to transform
     * @param {string} caseType - The case type to transform the value to ('lowercase', 'uppercase', or 'no_case')
     * @returns {string} The transformed string value, or the original value if transformation is not applicable
     */
    transformValueToGivenCase: (value, caseType) => {
        try {
        // Return the original value if it's not a string or if it's empty
        if (typeof value !== 'string' || !value) {
            return value;
        }

        // Transform the value based on the case type
        switch (caseType) {
            case 'lowercase':
            return value.toLowerCase();
            case 'uppercase':
            return value.toUpperCase();
            case 'no_case':
            default:
            // Return the original value for 'no_case' or if caseType is not specified
            return value;
        }
        } catch (error) {
        // If any error occurs during transformation, return the original value
        console.error('Error transforming case:', error);
        return value;
        }
    },

    /**
     * Retrieves the site value for a placement based on its properties and a vendor mapping map.
     * @param {Object} placement - The placement object containing site and publisher information.
     * @param {Object} campaignObj - campaign object containing partners.
     * @returns {string} - The site value, if found, otherwise returns 'Unassigned'.
    */
    getSiteValue: (placement, campaignObj) => {
        if(placement.mapped_planned_publisher && placement.mapped_planned_publisher.length){
            if(campaignObj.partners && campaignObj.partners.length){
                // Find the partner that matches the mapped planned publisher
                for (const publisherName of placement.mapped_planned_publisher) {
                    const partner = campaignObj.partners.find(p => p.toLowerCase() === publisherName.toLowerCase());
                    if (partner) {
                        return publisherName;
                    }
                }
                return placement.mapped_planned_publisher[0] || placement.site || 'Unassigned';
            } else {
                return placement.mapped_planned_publisher[0] || placement.site || 'Unassigned';
            }
        } else {
            return placement.site || 'Unassigned';
        }
    },

    /**
     * Update the taxonomy obj array with all the field type 10 elements.
     * @param {Object} taxonomyValueIdFields - takes the schema of the given media object.
     * @param {Object} taxonomyObjArray - takes in already existing taxonomy objects.
     * @param {Object} idAlreadyExistsFlag - flag to check if ID already exists.
     * @returns {Object} - The updated taxonomy object array.
    */
    insertTaxonomyValueIdsIntoTaxonomy: (taxonomyValueIdFields, taxonomyObjArray, idAlreadyExistsFlag = false, mediaTaxonomy = "", mediaTaxonomyDisplay = "") => {
        const newValue = `{TaxonomyValueID}`;
        taxonomyValueIdFields = taxonomyValueIdFields?.filter(tax => tax.field_type === 10);
        if (taxonomyValueIdFields.length > 0) {
            if (!idAlreadyExistsFlag) {
                taxonomyObjArray.push({
                    id: taxonomyValueIdFields[0]?.id,
                    code: newValue,
                    delimiter: taxonomyValueIdFields[0]?.delimiter_value
                });
                return { taxonomyObjArray };
            }
            const existingTaxonomy = taxonomyObjArray.filter(tax => tax.id === taxonomyValueIdFields[0]?.id);
            if (existingTaxonomy.length) {
                mediaTaxonomy = mediaTaxonomy.replace(existingTaxonomy[0].code, newValue)
                mediaTaxonomyDisplay = mediaTaxonomyDisplay.replace(existingTaxonomy[0].code, newValue)
                existingTaxonomy[0].code = newValue;
                existingTaxonomy[0].delimiter = taxonomyValueIdFields[0]?.delimiter_value;
            }
        }
        return { taxonomyObjArray, mediaTaxonomy, mediaTaxonomyDisplay };
    },
    
    /** The below code is updating the defaultTaxonomyFields array by mapping over the
    * `fields` array of `defaultTaxonomyDataCopy`. For each object in the `fields` array, it checks if
    * there is a matching `FieldId` in the `childitems` array of the first object in the `selectedObj`
    * array. If there is a match, it creates a new object with properties `field_id`, `name`, `code`,
    * and `id` from the matching child item, and pushes it to the `updatedFieldItems` array.
    * If the `updatedFieldItems` array has items, it pushes the updated object to the `dependentFields`
    * array and returns the updated object. If there are no items in the `updatedFieldItems` array, it
    * returns the original object.
    * @param {Object} defaultTaxonomyDataCopy - The default taxonomy data copy object.
    * @param {Object[]} selectedObj - The selected object array.
    * @param {string[]} dependentFields - The dependent fields array.
    * @returns {Object[]} - The updated default taxonomy fields array. 
  */
    updateDefaultTaxonomyFields : (defaultTaxonomyDataCopy, selectedObj) => {
        return defaultTaxonomyDataCopy && defaultTaxonomyDataCopy?.fields.map((obj, index) => {
            let updatedFieldItems = [];
            if(selectedObj?.length && Number(selectedObj[0]?.field_id) === Number(obj.id)) {
                selectedObj[0].fieldName = obj.alias || obj.name;
            }
            selectedObj && selectedObj[0]?.childitems?.forEach((child) => {
                if (Number(obj.id) === Number(child.FieldId)) {
                const childObj = defaultTaxonomyDataCopy?.fields[index]?.fielditems?.find((item) => Number(item.id) === Number(child.Id));
                updatedFieldItems.push(childObj);
                }
            });
            if (updatedFieldItems.length > 0) {
                obj.showExplicitInfo = false;
                return { ...obj, fielditems: updatedFieldItems, isCascaded: true};
            } else {
                return { ...obj };
            }
        });
    }
}